import type { VariantProps } from "class-variance-authority";
import { cn } from "../../utils/cn";
import { CheckIcon } from "../icons/check-icon";
import type { iconVariants } from "../icons/variants-icon";

export function AnimatedCheckmark({
  className,
  iconSize,
}: {
  className?: string;
  iconSize: VariantProps<typeof iconVariants>["size"];
}): React.JSX.Element {
  return (
    <div
      className={cn("zoom-in animate-in text-success-500 duration-300 ease-in motion-reduce:animate-none", className)}
    >
      <CheckIcon size={iconSize} />
    </div>
  );
}
